module.exports = __webpack_public_path__ + "static/media/background-card-robo.f22d1f1d.svg";